import { mapTree, extendDataItem } from "@progress/kendo-react-common";

export const processTreeData = (data, state, fields) => {
    const { selectField, expandField, dataItemKey, subItemsField, textField } = fields;
    const { expanded, value, filter } = state;
    const filtering = Boolean(filter && textField && filter.value);

    const filterFunc = (_item, _textField, _subItemsField) => {
        if (_item[_textField].toLowerCase().includes(filter.value.toLowerCase())) {
            return true;
        } else {
            var foundItems = _item[subItemsField].filter(s => filterFunc(s, _textField, _subItemsField));
            return foundItems && foundItems.length > 0;
        }
    }

    const mapFunc = (item) => {
        var match = item[textField].toLowerCase().includes(filter.value.toLowerCase())
        if (match)
            return item;

        var foundItems = item[subItemsField].filter(subItem => {
            return filterFunc(subItem, textField, subItemsField);
            //return subItem[textField].toLowerCase().includes(filter.value.toLowerCase()) || item[textField].toLowerCase().includes(filter.value.toLowerCase());
        });
        if (match || foundItems.length > 0)
            return { ...item, [subItemsField]: foundItems.map(f => mapFunc(f)) };

    }


    //Custom filtering so it returns all children of a parent that matches the filter OR only children that match the filter
    const filteredData = filtering ? data.map(item => {
        //console.log('mapFunc', item);
        // item[subItemsField]?.filter(subItem => {
        //     return filterFunc(subItem, textField, subItemsField);
        // })

        return mapFunc(item);
        //remove all sub items that don't match the filter
        // var foundItems = item[subItemsField].filter(subItem => {
        //     return subItem[textField].toLowerCase().includes(filter.value.toLowerCase()) || item[textField].toLowerCase().includes(filter.value.toLowerCase());
        // });
        // return { ...item, [subItemsField]: foundItems };
    }).filter(f => f) : data;

    //console.log('processTreeData', filteredData)


    return mapTree(
        filteredData,
        subItemsField,
        (item) => {
            const props = {
                [expandField]: filtering || expanded.includes(item[dataItemKey]),
                [selectField]: value && item[dataItemKey] === value[dataItemKey],
            };
            return filtering
                ? extendDataItem(item, subItemsField, props)
                : { ...item, ...props };
        }
    );
};

export const expandedState = (item, dataItemKey, expanded) => {
    const nextExpanded = expanded.slice();
    const itemKey = item[dataItemKey];
    const index = expanded.indexOf(itemKey);
    index === -1 ? nextExpanded.push(itemKey) : nextExpanded.splice(index, 1);

    return nextExpanded;
};